export default Object.freeze({
	Center: 'c',
	Top: 't',
	TopRightAligned: 't-r',
	Right: 'r',
	RightBottomAligned: 'r-b',
	Bottom: 'b',
	BottomRightAligned: 'b-r',
	Left: 'l',
	LeftBottomAligned: 'l-b',
});
